(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-main-product"] && !Shopify.designMode) return;
  try {
    
  class GbProductHero {
    constructor(root) {
      this.root = root;
      this.initGallery();
      this.initVariants();
      this.initCarousel();
      this.initDirectCheckout();
      this.initAddToCart();
    }

    initGallery() {
      const frames = Array.from(this.root.querySelectorAll('[data-gb-media-frame]'));
      if (!frames.length) return;
      const thumbs = Array.from(this.root.querySelectorAll('[data-gb-media-thumb]'));
      let index = 0;

      const show = (next) => {
        index = (next + frames.length) % frames.length;
        frames.forEach((frame, i) => frame.classList.toggle('is-active', i === index));
        thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      };

      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      const prev = this.root.querySelector('[data-gb-media-prev]');
      const next = this.root.querySelector('[data-gb-media-next]');
      if (prev) prev.addEventListener('click', () => show(index - 1));
      if (next) next.addEventListener('click', () => show(index + 1));
    }

    initVariants() {
      const options = Array.from(this.root.querySelectorAll('[data-gb-variant-option]'));
      if (!options.length) return;
      const input = this.root.querySelector('[data-gb-variant-input]');
      const price = this.root.querySelector('[data-gb-price]');
      const button = this.root.querySelector('[data-gb-atc]');
      const label = this.root.querySelector('[data-gb-atc-label]');
      const defaultLabel = label ? label.textContent.trim() : '';

      options.forEach((option) => {
        option.addEventListener('change', () => {
          if (!option.checked) return;
          options.forEach((other) => {
            const card = other.closest('.gb-hero__bundle');
            if (card) card.classList.toggle('is-active', other === option);
          });
          if (input) input.value = option.value;
          if (price) price.textContent = option.dataset.gbVariantPrice;
          const available = option.dataset.gbVariantAvailable === 'true';
          if (button) button.disabled = !available;
          if (label) label.textContent = available ? defaultLabel : 'Agotado';
        });
      });
    }

    initDirectCheckout() {
      const form = this.root.querySelector('.gb-hero__form');
      if (!form || !form.querySelector('[data-gb-direct-checkout]')) return;

      const button = form.querySelector('[data-gb-atc]');
      const label = form.querySelector('[data-gb-atc-label]');
      const input = form.querySelector('[data-gb-variant-input]');
      if (!input) return;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const original = label ? label.textContent : '';
        if (button) button.disabled = true;
        if (label) label.textContent = 'Procesando...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }] }),
          });
          if (!res.ok) throw new Error('cart/add failed');
          window.location.href = '/checkout';
        } catch (error) {
          if (label) label.textContent = original;
          if (button) button.disabled = false;
          form.submit();
        }
      });
    }

    initAddToCart() {
      const button = this.root.querySelector('[data-gb-cart]');
      if (!button) return;

      const label = button.querySelector('[data-gb-cart-label]');
      const input = this.root.querySelector('[data-gb-variant-input]');
      if (!input) return;

      button.addEventListener('click', async () => {
        const original = label ? label.textContent : '';
        button.disabled = true;
        if (label) label.textContent = 'Anadiendo...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }] }),
          });
          if (!res.ok) throw new Error('cart/add failed');

          if (label) label.textContent = 'Anadido';

          document.dispatchEvent(
            new CustomEvent('cart:lines-update', {
              bubbles: true,
              detail: { source: 'gb-hero' },
            })
          );
          setTimeout(() => {
            if (label) label.textContent = original;
            button.disabled = false;
          }, 2000);
        } catch (error) {
          if (label) label.textContent = 'No se pudo anadir';
          setTimeout(() => {
            if (label) label.textContent = original;
            button.disabled = false;
          }, 2500);
        }
      });
    }

    initCarousel() {
      const wrapper = this.root.querySelector('[data-gb-carousel]');
      if (!wrapper) return;
      const track = wrapper.querySelector('[data-gb-carousel-track]');
      if (!track) return;
      const step = () => track.clientWidth;
      const prev = wrapper.querySelector('[data-gb-carousel-prev]');
      const next = wrapper.querySelector('[data-gb-carousel-next]');
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    }
  }

  const gbInitProductHeroes = () => {
    document.querySelectorAll('[data-gb-product]').forEach((root) => {
      if (root.dataset.gbReady === 'true') return;
      root.dataset.gbReady = 'true';
      new GbProductHero(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gbInitProductHeroes);
  } else {
    gbInitProductHeroes();
  }

  document.addEventListener('shopify:section:load', gbInitProductHeroes);

  const gbInitCutoff = () => {
    document.querySelectorAll('[data-gb-cutoff]').forEach((el) => {
      if (el.dataset.gbReady === 'true') return;
      el.dataset.gbReady = 'true';

      const out = el.querySelector('[data-gb-cutoff-text]');
      const [hh, mm] = (el.dataset.gbCutoff || '').split(':').map(Number);
      if (!out || Number.isNaN(hh)) return;

      const offset = el.dataset.gbCutoffOffset || '-05:00';
      const weekdaysOnly = el.dataset.gbCutoffWeekdays === 'true';
      const before = el.dataset.gbCutoffBefore || '';
      const after = el.dataset.gbCutoffAfter || '';

      const cutoffFor = (dayShift) => {
        const now = new Date();
        const local = new Date(now.getTime());
        local.setUTCDate(local.getUTCDate() + dayShift);
        const y = local.getUTCFullYear();
        const m = String(local.getUTCMonth() + 1).padStart(2, '0');
        const d = String(local.getUTCDate()).padStart(2, '0');
        const H = String(hh).padStart(2, '0');
        const M = String(mm || 0).padStart(2, '0');
        return new Date(`${y}-${m}-${d}T${H}:${M}:00${offset}`);
      };

      const isWeekend = (date) => {
        const wd = date.getUTCDay();
        return wd === 0 || wd === 6;
      };

      const render = () => {
        const now = Date.now();
        const todayCutoff = cutoffFor(0);
        const openToday = !weekdaysOnly || !isWeekend(todayCutoff);
        const left = todayCutoff.getTime() - now;

        if (openToday && left > 0) {
          const h = Math.floor(left / 3600000);
          const m = Math.floor((left % 3600000) / 60000);
          const txt = h > 0 ? `${h} h ${m} min` : `${m} min`;
          out.innerHTML = before.replace('[t]', `<b>${txt}</b>`);
        } else {
          out.textContent = after;
        }
        el.hidden = false;
      };

      render();
      setInterval(render, 30000);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gbInitCutoff);
  } else {
    gbInitCutoff();
  }

  document.addEventListener('shopify:section:load', gbInitCutoff);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-photos"] && !Shopify.designMode) return;
  try {
    
  const gbInitPhotos = () => {
    document.querySelectorAll('[data-gb-photos]').forEach((root) => {
      if (root.dataset.gbReady === 'true') return;
      root.dataset.gbReady = 'true';

      const track = root.querySelector('[data-gb-photos-track]');
      if (!track) return;

      const step = () => {
        const card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      };

      const prev = root.querySelector('[data-gb-photos-prev]');
      const next = root.querySelector('[data-gb-photos-next]');
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gbInitPhotos);
  } else {
    gbInitPhotos();
  }

  document.addEventListener('shopify:section:load', gbInitPhotos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-subscription-banner"] && !Shopify.designMode) return;
  try {
    
  const gbInitCountdown = () => {
    document.querySelectorAll('[data-gb-countdown]').forEach((root) => {
      if (root.dataset.gbReady === 'true') return;
      root.dataset.gbReady = 'true';

      const target = new Date(root.dataset.gbCountdown).getTime();
      if (Number.isNaN(target)) return;

      const d = root.querySelector('[data-gb-cd-d]');
      const h = root.querySelector('[data-gb-cd-h]');
      const m = root.querySelector('[data-gb-cd-m]');
      const s = root.querySelector('[data-gb-cd-s]');
      const text = root.querySelector('[data-gb-cd-text]');
      const hideExpired = root.dataset.gbCountdownHide === 'true';
      const pad = (n) => String(n).padStart(2, '0');

      const tick = () => {
        const left = target - Date.now();

        if (left <= 0) {
          if (hideExpired) root.hidden = true;
          [d, h, m, s].forEach((el) => { if (el) el.textContent = '00'; });
          if (text) text.textContent = 'La oferta ha terminado.';
          clearInterval(timer);
          return;
        }

        const days = Math.floor(left / 86400000);
        const hours = Math.floor((left % 86400000) / 3600000);
        const mins = Math.floor((left % 3600000) / 60000);
        const secs = Math.floor((left % 60000) / 1000);

        if (d) d.textContent = pad(days);
        if (h) h.textContent = pad(hours);
        if (m) m.textContent = pad(mins);
        if (s) s.textContent = pad(secs);
        if (text) text.textContent = `Quedan ${days} días, ${hours} horas y ${mins} minutos.`;
      };

      tick();
      const timer = setInterval(tick, 1000);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gbInitCountdown);
  } else {
    gbInitCountdown();
  }

  document.addEventListener('shopify:section:load', gbInitCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-testimonials"] && !Shopify.designMode) return;
  try {
    
  const gbInitTestimonials = () => {
    document.querySelectorAll('[data-gb-testi]').forEach((root) => {
      if (root.dataset.gbReady === 'true') return;
      root.dataset.gbReady = 'true';

      const track = root.querySelector('[data-gb-testi-track]');
      if (!track) return;

      const step = () => {
        const card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      };

      const prev = root.querySelector('[data-gb-testi-prev]');
      const next = root.querySelector('[data-gb-testi-next]');
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gbInitTestimonials);
  } else {
    gbInitTestimonials();
  }

  document.addEventListener('shopify:section:load', gbInitTestimonials);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();
})();
